/** @jsx jsx */
import { jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { addFirstProgramAssets, s3CourseraAssetURL } from 'bundles/enterprise-admin-constants/assets';
import { Button } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-admin-home';

type Props = {
  canManageOrganization: boolean;
  navigateToProgramContract: () => void;
  disableAddProgramButton: boolean;
};

function AdminLandingAddFirstProgram({
  canManageOrganization,
  navigateToProgramContract,
  disableAddProgramButton,
}: Props) {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: 'var(--cds-spacing-300)',
        boxShadow: '0 2px 4px 0 var(--cds-color-darken-100)',
        background: 'linear-gradient(to bottom right, var(--cds-color-blue-300), var(--cds-color-blue-600))',
        position: 'relative',
      }}
    >
      <Imgix
        css={{
          left: '0',
          top: '0',
          height: '100%',
          position: 'absolute',
        }}
        src={s3CourseraAssetURL + addFirstProgramAssets.leftImagePath}
        alt=""
      />
      <Imgix
        className="hidden-md-down"
        css={{
          top: '0',
          right: '0',
          height: '100%',
          position: 'absolute',
        }}
        src={s3CourseraAssetURL + addFirstProgramAssets.rightImagePath}
        alt=""
      />
      <h2
        css={{
          maxWidth: '65%',
          margin: '0 auto',
          padding: '5rem 0 4rem',
          color: 'var(--cds-color-neutral-primary-invert)',
          textAlign: 'center',
        }}
      >
        {disableAddProgramButton
          ? _t('This account has not yet been enabled. Please reach out to your Coursera representative.')
          : _t('Add a learning program so your team can start learning on Coursera.')}
      </h2>
      {!disableAddProgramButton && (
        <div
          css={{
            textAlign: 'center',
            paddingBottom: '6rem',
          }}
        >
          <Button
            variant="secondary"
            style={{ padding: '1.75rem 3rem' }}
            disabled={!canManageOrganization}
            onClick={canManageOrganization ? navigateToProgramContract : undefined}
          >
            {_t('Add program and invite people')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default AdminLandingAddFirstProgram;
